import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminReportManagementPage from '../components/reports/AdminReportManagementPage';
import * as catalogActions from '../redux/actions/catalogActions';

function mapStateToProps(state) {
  return {
    catalog: state.catalog,
    user: state.catalog?.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...catalogActions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminReportManagementPage);
